<template>
  <v-card>
    <v-card-text>
      <v-row>
        <mrc_ess_bulkFile @changeFile="changeFile"></mrc_ess_bulkFile>
        <v-col cols="12">
          <div
            v-for="(item, index) in viewFormDate"
            class="d-flex justify-space-between align-center"
            :key="index"
          >
            <div>
              <mrc_ess_svgIcon
                :iconClass="'filetype-' + suffix(item.name)"
                style="font-size: 23px"
              />
              <span class="mx-1">{{ item.name }}</span>
              <span>({{ item.size }}KB)</span>
            </div>
            <div v-show="!disabled">
              <v-icon
                class="material-icons"
                @click="deleteviewfile(item, index)"
                style="font-size: 28px"
                >delete</v-icon
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @cancel="cancel"
      @success="success"
      :loading="loading"
      :cancelText="cancelText || $t('label_cancel')"
      :successText="successText || $t('label_submit')"
    ></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { add_file } from "@/service/api/file";

export default {
  props: {
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewFormDate: [],
      loading: false,
      file_uuid: "",
    };
  },
  mounted() {
    if (this.$route.query.file_uuid) {
      this.file_uuid = this.$route.query.file_uuid;
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1); //返回上一级
      this.loading = false;
    },
    async success() {
      this.loading = true;
      //对文件进行处理

      let fileuuids = await this.uploadFilesMore();

      if (fileuuids != undefined && fileuuids.length > 0) {
        var filename = [];
        this.viewFormDate.forEach((element) => {
          filename.push(element.name);
        });

        var res = await add_file({
          directory_uuid: this.file_uuid,
          file_name: filename.join(","),
          attachments_uuid: fileuuids.join(","),
          directory_type: 2,
        });

        if (res.code == 200) {
          this.$router.go(-1);
        }
      } else {
        this.$Message({
          text: this.$t("error_ADD_FILE_CALLBACK_FAIL"),
        });
      }
      this.loading = false;
    },
    changeFile(v) {
      this.viewFormDate.push(v);
    },
    suffix(val) {
      return val.slice(val.indexOf(".") + 1);
    },
    deleteviewfile(val, index) {
      this.viewFormDate.splice(index, 1);
    },
    async uploadFilesMore() {
      let fileuuids = [];
      let url = [];

      for (let i = 0; i < this.viewFormDate.length; i++) {
        const res = await this.$uploadFiles([this.viewFormDate[i]], {
          module_uuid:'companydoc',
          function_uuid: this.$store.state.menuFunctionUuid,
          attachment_data_table: "mrbase_sys_document",
          attachment_data_field: "attachments_uuid",
          org_level_uuid: this.$store.state.currentCompany,
          uuid: this.$store.state.currentCompanyClientUuid,
        });

        if (typeof res == "object" && res != undefined && res.code == 200) {
          fileuuids.push(res.uuid);
          url.push(res.uuid);
        } else {
          url.forEach((element) => {
            this.$deleteFile(element);
          });
          fileuuids = [];
          return [];
        }
      }
      return fileuuids;
    },
  },
};
</script>

<style scoped></style>
